import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from ".";
import { URI } from "../../constants/URI";
import { setActiveGroup, setGroups, setMembers } from "../slices/groupSlice";
import { setActiveGroupId } from "../slices/messageSlice";
import { store } from "../store";
import { getRoutes } from './../../constants/Routes';

export const getGroups = async ({ search } = {}) => {
    const res = await handleGetRequest(URI.group, null, { params: { search } });
    if (res?.ack) store.dispatch(setGroups(res?.data));
    return res;
};

export const getGroupById = async (id) => {
    const res = await handleGetRequest(URI.group_id(id));
    if (res?.ack) {
        store.dispatch(setActiveGroup(res?.data));
        store.dispatch(setActiveGroupId(res?.data?.id));
    }
    return res;
};

export const createGroup = async (data) => {
    const res = await handlePostRequest(URI.group, data);
    if (res?.ack) getGroups();
    return res;
};

export const updateGroup = async (id, data) => {
    const res = await handlePutRequest(URI.group_id(id), data);
    if (res?.ack) {
        getGroups();
        if (store.getState()?.groupSlice?.activeGroup?.id === id) {
            getGroupById(id);
        }
    }
    return res;
};

export const deleteGroup = async (id) => {
    const res = await handleDeleteRequest(URI.group_id(id));
    if (res?.ack && store.getState()?.groupSlice?.activeGroup?.id === id) {
        window.location.href = getRoutes().groups.route();
    }
    if (res?.ack) getGroups();
    return res;
};

export const getGroupMembers = async (groupId) => {
    const res = await handleGetRequest(URI.group_members(groupId), null, {
        module: 'GET_GROUP_MEMBERS',
    });
    if (res?.ack) store.dispatch(setMembers(res?.data));
    return res;
};

export const addGroupMembers = async (groupId, data) => {
    const res = await handlePostRequest(URI.group_members(groupId), data);
    if (res?.ack) {
        getGroupMembers(groupId);
        if (groupId === store.getState()?.groupSlice?.activeGroup?.id) {
            getGroupById(groupId);
        }
    }
    return res;
};

export const removeGroupMembers = async (groupId, data) => {
    const res = await handleDeleteRequest(URI.group_members(groupId), data);
    if (res?.ack) {
        getGroupMembers(groupId);
        if (groupId === store.getState()?.groupSlice?.activeGroup?.id) {
            getGroupById(groupId);
        }
    }
    return res;
};
